export default __webpack_public_path__ + "static/media/334.66edfef5.jpg";